import WhiteSpaceFilter from "./whitespace.js";
import CommentsFilter from "./comments.js";
import ScriptsFilter from "./scripts.js";
import UndisplayedFilter from "./undisplayed.js";

export default [
	WhiteSpaceFilter,
	CommentsFilter,
	ScriptsFilter,
	UndisplayedFilter
];
